import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {ConfirmationService} from 'primeng/api';

import {AuthService, AuthUser, TokenService} from '../../../../core/auth';
import {Customer} from '../../../../core/models/';
import {CustomerService} from '../../../../core/services/';
import {BreadcrumbService} from '../../../../breadcrumb.service';
import {TopbarService} from '../../../../topbar.service';


@Component({
  selector: 'app-customer-details',
  templateUrl: './customer-details.page.html'
})
export class CustomerDetailsPage implements OnInit {
  @Input() customer: Customer;
  customerOrig: Customer;
  saving = false;
  loading = false;
  authUser: AuthUser = this.token.whoAmI();
  id: string;

  switchCustomer = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private customerService: CustomerService,
    private confirmationService: ConfirmationService,
    private token: TokenService,
    private authService: AuthService,
    private topbarService: TopbarService,
    private breadcrumbService: BreadcrumbService
  ) {
  }

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id');
    if (this.id) {
      this.loadCustomer(this.id);
    }


  }

  loadCustomer(id) {
    this.loading = true;
    this.customerService.getOne(id).subscribe(
      (data) => {
        this.customerOrig = this.customer = data;
        this.loading = false;

        this.breadcrumbService.setItems([
          {label: 'admin', routerLink: ['/admin', 'dashboard']},
          {label: 'customer', routerLink: ['/admin', 'customer', 'list']},
          {label: this.customer.name}
        ]);
        this.switchCustomer = this.showSwitchToCustomer();
      },
      (error) => {
        this.loading = false;
      }
    );
  }

  showSwitchToCustomer() {
    return this.authUser.loginCustomer.name != this.customer.name && this.authUser.currentCustomer.name != this.customer.name;
  }

  switchToCustomer() {
    this.authService.switchCustomer(this.authUser.username, this.customer.name).subscribe(
      (data) => {
        this.token.saveToken(data.token);
        this.authUser = this.token.whoAmI();
        this.switchCustomer = this.showSwitchToCustomer();
        this.topbarService.setCustomerItems(this.authUser.currentCustomer);
      }
    );

  }

  backToList() {
    this.router.navigate(['/admin', 'customer', 'list']);
  }

  saveCustomer() {
    this.saving = true;
    this.updateCustomer(this.customer);
  }


  updateCustomer(customer: Customer) {
    this.customerService.update(customer)
      .subscribe(
        (data) => {
          this.backToList();
          delete (this.saving);
        },
        (error) => {
          delete (this.saving);
        }
      );
  }

  confirm(state) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to ' + state + ' this customer?',
      accept: () => {
        this.toggle(this.customer);
      }
    });
  }

  toggle(customer: Customer) {
    this.toggleCustomerStatus(this.customerOrig);
    this.customerService.update(this.customerOrig).subscribe(
      (data) => {
        this.customer = this.customerOrig;
      }
    );
  }

  toggleCustomerStatus(customer: Customer) {
    if (customer.status === 'A') {
      customer.status = 'I';
    } else {
      customer.status = 'A';
    }
  }
}
